<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="Same Day Reservations"/>
    </div>
    <mdb-card class="text-left">
      <mdb-card-header class="secondary-color text-white">
        <h5>{{ capitalize($tc('common.label.member',1)) }} with {{ $tc('common.label.reservation',1) }} on the same day for different {{ $tc('common.label.event',2) }}</h5>
      </mdb-card-header>
      <mdb-card-body>
        <div v-if="reservations && reservations.length == 0">
          None found
        </div>
        <mdb-tbl v-if="reservations && reservations.length> 0" responsive striped>
          <mdb-tbl-body>
            <tr v-for="(r,i) in reservations" v-bind:key="i">
              <td>
                <avatar :avatar="r.avatar"/>
              </td>
              <router-link :to="'/event/show/' + r.eventId" class="text-secondary">
                <td>

                  {{ r.name }}<br/>
                  {{ r.eventTitle }}<br/>
                  {{ r.startDate }}, <b><i>{{r.status}}</i></b><br/>
                </td>
              </router-link>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>
    </mdb-card>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import {mapState} from 'vuex'
import {mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbTbl, mdbTblBody, mdbTblHead,} from 'mdbvue';
import Avatar from "../common/Avatar";

export default {
  name: "group-events",
  components: {
    mdbContainer,
    mdbIcon,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    bannerSmall,
    Avatar
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup,
                       settings: state => state.settings
                     }),
  data() {
    return {
      reservations: null
    }
  },
  mounted() {
    document.title = "Same Day Reservations"
    this.$store.dispatch("setExecuting", true)
    api.get("/reservation/sameDayReservations/" + this.$route.params.id).then(
      (results) => {
        this.reservations = results.data.reservations
        if (!this.currentGroup || this.currentGroup.id != results.data.groupId) {
          api.groupBasics(results.data.groupId, "public");
        }
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  }
};

</script>

